import { render, staticRenderFns } from "./VectorWidget.vue?vue&type=template&id=ef61927e&scoped=true&"
import script from "./VectorWidget.vue?vue&type=script&lang=js&"
export * from "./VectorWidget.vue?vue&type=script&lang=js&"
import style0 from "./VectorWidget.vue?vue&type=style&index=0&id=ef61927e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef61927e",
  null
  
)

export default component.exports